import moment from "moment";
// The ES module build of the locale registers itself into the same moment copy the app uses,
// "moment/locale/cs" would end up in a separate CommonJS copy and the dates would stay in English
import "moment/dist/locale/cs";
moment.locale("cs");

export const monthNames = [
    "leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"
];

export const getDateWithoutTime = (date: Date): Date => {
    return new Date(moment(date).format("YYYY-MM-DDT00:00:00"));
};

export const getStartOfMonth = (year: number, month: number): Date => {
    return new Date(moment(new Date(year, month, 1)).format("YYYY-MM-DDT00:00:00") + "Z");
};

export const getPreviousMondayDate = (date: Date): Date => {
    const onlyDate = new Date(moment(date).format("YYYY-MM-DDT00:00:00") + "Z");
    const mom = moment(onlyDate);
    const weekDay = mom.isoWeekday() - 1;
    return weekDay === 0 ? onlyDate : mom.add(-weekDay, "day").toDate();
};

export const addDays = (date: Date, days: number): Date => {
    return moment(date).utc().add(days, "days").toDate();
};

export const addHours = (date: Date, hours: number): Date => {
    return moment(date).add(hours, "hours").toDate();
};

export const toLongDateString = (date: Date): string => {
    return moment(date).format("dddd D. MMMM");
};

export const parseDateToString = (value: Date): string => {
    if (value === null || value === undefined) {
        return "";
    }
    return moment(value).format("LLL");
};

export const parseDateToDateString = (value: Date): string => {
    if (value === null || value === undefined) {
        return "";
    }
    return moment(value).format("LL");
};

export const parseDateToDate = (value?: Date): Date | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }
    return moment(value).toDate();
};

export const getFriendlyDateString = (date: Date) => {
    const today = parseDateToDateString(new Date());
    if (parseDateToDateString(date) === today) { return "Dnes"; }
    if (parseDateToDateString(addDays(date, 1)) === today) { return "Včera"; }
    return toLongDateString(date);
};

export const getCurrentTime = () => {
    const date = moment();
    return date.format("HH:00");
};

export const getTimeFromDate = (date?: Date): string => {
    return date ? moment(date).format("HH:mm") : "";
};

export const isValidDate = (value?: Date | null): value is Date => {
    return value instanceof Date && !isNaN(value.getTime());
};

export const isValidTime = (value: string): boolean => {
    return value.length === 5 && /^(2[0-3]|[0-1]?[\d]):[0-5][\d]$/.test(value) || value.length === 4 && /^(2[0-3]|[0-1]?[\d]):?[0-5][\d]$/.test(value);
};

export const setTimeInDate = (dateValue: Date, timeValue: string): Date => {
    const time: moment.Moment = moment(timeValue, "HH:mm");
    const dateWithoutTime: Date = getDateWithoutTime(dateValue);
    const date: moment.Moment = moment(dateWithoutTime);
    if (dateWithoutTime.getTimezoneOffset() !== dateValue.getTimezoneOffset()) {
        date.add(Math.abs(dateValue.getTimezoneOffset()), "m");
    }
    date.add(time.hours(), "h");
    date.add(time.minute(), "m");
    return date.toDate();
};

export const getRemainingTimeFromNow = (value: Date): string => {
    if (value === null || value === undefined) {
        return "";
    }
    const zeroPad = (num: number, places: number) => String(num).padStart(places, "0");
    const start = moment(value);
    const duration = moment.duration(start.diff(moment()));
    const days = parseInt(duration.asDays().toString());
    const hours = Math.abs(parseInt(duration.asHours().toString()));
    const minutes = Math.abs(parseInt((duration.asMinutes() % 60).toString()));
    const seconds = Math.abs(parseInt((duration.asSeconds() % 60).toString()));
    const expired = parseInt((duration.asSeconds() % 60).toString()) < 0;
    const hoursCalculated = Math.abs(hours - (days * 24) >= 0 ? hours - (days * 24) : hours);
    return `${expired ? "-" : ""}${days}d ${zeroPad(hoursCalculated, 2)}h ${zeroPad(minutes, 2)}m ${zeroPad(seconds, 2)}s`;
};

export const dueDateColor = (date: Date): string => new Date(date).getTime() <= new Date().getTime() ? "#da4f43" : "inherit";

export const getDefaultStartDate = (): Date => {
    const now = moment();
    const currentMin = now.minute();
    let min = 0;

    if (currentMin < 15) { min = 0; }
    else if (currentMin < 30) { min = 15; }
    else if (currentMin < 45) { min = 30; }
    else { min = 45; }

    now.set("minute", min);
    return now.toDate();
};
